module.exports = __webpack_public_path__ + "img/upload.a768993a.svg";